var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { UserSubjectStatusEnum } from '@/models/UserSubject';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import SubjectStatusSelect from '@/components/subject-status-select/SubjectStatusSelect';
import { UserSubject } from '@/models/UserSubject';
import ErrorHandler from '@/support/ErrorHandler';
import AlertCard from '@/components/alert-card/AlertCard';
import Rating from '@/components/rating/Rating';
let BulkUpdateStatusFinishedRatingDialog = class BulkUpdateStatusFinishedRatingDialog extends Vue {
    constructor() {
        super(...arguments);
        this.bulkUpdateSubjectListLength = 0;
        this.finishedNote = null;
        this.rating = null;
        this.finishedFile = null;
        this.inputElement = null;
        this.isSubmitting = false;
        this.isSubmitted = false;
        this.isTakingTooLong = false;
        this.totalOperations = 0;
        this.totalOperationsCompleted = 0;
    }
    mounted() {
        this.bulkUpdateSubjectListLength = this.bulkUpdateSubjectList.length;
    }
    onFileChange(event) {
        if (!event.target.files.length === null) {
            return;
        }
        this.inputElement = event.target;
        this.finishedFile = event.target.files[0];
    }
    removeSelectedFile() {
        this.finishedFile = null;
        if (this.inputElement) {
            this.inputElement.removeAttribute('value');
            this.inputElement.setAttribute('value', '');
        }
    }
    clear() {
        this.isSubmitting = false;
        this.isSubmitted = false;
        this.isTakingTooLong = false;
        this.finishedNote = null;
        this.rating = 0;
        this.finishedFile = null;
        this.inputElement = null;
    }
    closeDialog() {
        this.clear();
        this.$emit('input', false);
    }
    submit() {
        this.isSubmitting = true;
        this.update();
    }
    update() {
        const payload = {
            subjects: this.bulkUpdateSubjectList,
            status: UserSubjectStatusEnum.FINISHED,
        };
        payload.finished_note = this.finishedNote || '';
        payload.rating = this.rating || 0;
        if (this.finishedFile) {
            payload.file = this.finishedFile;
            payload.collection = 'finished';
        }
        new UserSubject().bulkUpdate(payload)
            .then(() => {
            this.isSubmitting = false;
            this.$nextTick(() => {
                this.isSubmitted = true;
            });
        })
            .catch((error) => {
            this.isSubmitting = false;
            this.isSubmitted = false;
            ErrorHandler.network(error);
        });
    }
    get isDisabled() {
        return false;
    }
    isSubmittingChanged(isSubmitting, wasUploading) {
        if (isSubmitting) {
            this.takingTooLongTimeout = setTimeout(() => {
                this.isTakingTooLong = true;
            }, 30000);
        }
        else {
            this.isTakingTooLong = false;
            clearTimeout(this.takingTooLongTimeout);
        }
    }
    isSubmittedChanged(isSubmitted, wasSubmitted) {
        if (isSubmitted) {
            this.$emit('status-changed');
        }
    }
    newRating(rating) {
        this.rating = rating;
    }
};
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], BulkUpdateStatusFinishedRatingDialog.prototype, "bulkUpdateSubjectList", void 0);
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], BulkUpdateStatusFinishedRatingDialog.prototype, "input", void 0);
__decorate([
    Watch('isSubmitting'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean, Boolean]),
    __metadata("design:returntype", void 0)
], BulkUpdateStatusFinishedRatingDialog.prototype, "isSubmittingChanged", null);
__decorate([
    Watch('isSubmitted'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean, Boolean]),
    __metadata("design:returntype", void 0)
], BulkUpdateStatusFinishedRatingDialog.prototype, "isSubmittedChanged", null);
BulkUpdateStatusFinishedRatingDialog = __decorate([
    Component({
        components: {
            SubjectStatusSelect,
            AlertCard,
            Rating,
        },
    })
], BulkUpdateStatusFinishedRatingDialog);
export default BulkUpdateStatusFinishedRatingDialog;
